export default __webpack_public_path__ + "static/media/instagram-red.9b4989a5.svg";